const GET = 'GET_GAME';

const gameReducer = (state = {}, action) => {
  const game = action.game;
  switch(action.type){
    case GET:
     return {
      ...state,
      data:game
     }
    default:
     return state  
   }
  }
  export default gameReducer


  export const get = game => {
    return { type: GET, game };
}